// Only supported search routes participate; other pages retain their existing scroll policy.
export function searchView(location, mode = 'idle') {
  const match = location.pathname.match(
    /^\/search(?:\/(summary|reviews|artists|lists|mixes))?\/?$/,
  );
  if (!match) return null;
  const params = new URLSearchParams(location.search);
  const category = match[1] || 'home';
  const query = params.get('q')?.trim() || '';
  const page = Math.max(1, Number(params.get('page')) || 1);
  const url = JSON.stringify([
    category,
    query,
    category === 'home' || category === 'summary' ? 1 : page,
  ]);
  return { category, query, url, mode, key: JSON.stringify([location.key, url, mode]) };
}
export const isSearchScrollRoute = (pathname) => Boolean(searchView({ pathname, search: '' }));
export function createSearchViewMemory() {
  const positions = new Map(),
    latest = new Map(),
    choices = new Map();
  return {
    save(view, y) {
      if (!view || !Number.isFinite(y)) return;
      const value = Math.max(0, y);
      positions.set(view.key, value);
      latest.set(`${view.url}:${view.mode}`, value);
      // Session memory is bounded and never written to local/session storage.
      if (positions.size > 120) positions.delete(positions.keys().next().value);
      if (latest.size > 120) latest.delete(latest.keys().next().value);
    },
    position(view, previous, navigationType) {
      // Build58 resets the active search scroller on a fresh editing transition.
      if (view.mode === 'assist' && previous?.url === view.url && previous.mode === 'idle')
        return 0;
      if (navigationType === 'POP' && positions.has(view.key)) return positions.get(view.key);
      if (
        previous?.url === view.url &&
        (previous.mode !== view.mode || navigationType === 'REPLACE')
      )
        return latest.get(`${view.url}:${view.mode}`) ?? 0;
      if (view.category === 'home' && view.mode === 'idle')
        return latest.get(`${view.url}:idle`) ?? 0;
      if (
        view.category === 'summary' &&
        previous &&
        !['home', 'summary'].includes(previous.category) &&
        previous.query === view.query
      )
        return latest.get(`${view.url}:${view.mode}`) ?? 0;
      return 0;
    },
    choose(slot, dependencies, choose) {
      const previous = choices.get(slot);
      if (
        previous &&
        dependencies.length === previous.dependencies.length &&
        dependencies.every((value, index) => Object.is(value, previous.dependencies[index]))
      )
        return previous.value;
      const value = choose();
      choices.set(slot, { dependencies, value });
      return value;
    },
    clear() {
      positions.clear();
      latest.clear();
      choices.clear();
    },
  };
}
